import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getHotArticles } from '@/utils/data';

const slides = getHotArticles(5);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  const go = useCallback((next: number) => {
    setIndex((next + slides.length) % slides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % slides.length), 5000);
    return () => clearInterval(timer);
  }, []);

  const active = slides[index];

  return (
    <section className="relative h-[560px] w-full overflow-hidden md:h-[640px]">
      {slides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? 'opacity-100' : 'opacity-0'}`}
        >
          <img
            src={slide.cover}
            alt={slide.title}
            title={`${slide.title} - 色哟哟娱乐资讯`}
            className="h-full w-full object-cover object-top"
          />
        </div>
      ))}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/40 to-black/65"></div>

      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center px-4 text-center md:px-8">
        <span className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-primary-500/90 px-4 py-1.5 text-xs font-medium text-background-50">
          <i className="ri-flashlight-fill"></i>
          今日焦点 · 色哟哟
        </span>
        <h1 className="font-brand text-3xl text-background-50 md:text-5xl">色哟哟 · 多元娱乐资讯平台</h1>
        <p className="mt-3 max-w-2xl text-sm text-background-100/80 md:text-base">
          汇聚影视、音乐、明星与潮流的前沿动态，读懂每一次流行。
        </p>

        <div className="mt-8 w-full max-w-3xl rounded-lg bg-black/25 p-6 backdrop-blur-sm md:p-8">
          <div className="mb-3 flex items-center justify-center gap-2">
            <span className="rounded-full bg-primary-500 px-3 py-0.5 text-xs font-medium text-background-50">
              {active.categoryName}
            </span>
            <span className="text-xs text-background-100/70">{active.date}</span>
          </div>
          <Link to={`/detail/${active.id}`} className="group block cursor-pointer">
            <h2 className="text-xl font-bold text-background-50 transition-colors group-hover:text-primary-200 md:text-3xl">
              {active.title}
            </h2>
          </Link>
          <p className="mx-auto mt-3 hidden max-w-xl text-sm text-background-100/80 sm:block">{active.summary}</p>
          <Link
            to={`/detail/${active.id}`}
            className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            阅读全文
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 flex items-center gap-3">
          <button
            type="button"
            aria-label="上一条"
            onClick={() => go(index - 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 transition-colors hover:bg-primary-500 cursor-pointer"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>
          <div className="flex items-center gap-2">
            {slides.map((s, i) => (
              <button
                key={s.id}
                type="button"
                aria-label={`第 ${i + 1} 条`}
                onClick={() => go(i)}
                className={`h-2 rounded-full transition-all cursor-pointer ${i === index ? 'w-6 bg-primary-500' : 'w-2 bg-background-50/50'}`}
              ></button>
            ))}
          </div>
          <button
            type="button"
            aria-label="下一条"
            onClick={() => go(index + 1)}
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 transition-colors hover:bg-primary-500 cursor-pointer"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}